import userEvent from "@testing-library/user-event";
import { listeners } from "pouchdb";
import { useState, useEffect } from "react";

export const useLiveClient = (db) => {
  const [liveClient, setLiveClient] = useState(undefined);

  useEffect(() => {
    let changes;
    let mounted = true;
    if (db !== undefined && db !== null) {
      const setInitialClient = () => {
        console.log("setInitialClient db: ", db);
        return db
          .get("client")
          .then((client) => {
            console.log("setInitialClient premounted: ", client);
            if (mounted) {
              console.log("setInitialClient hook: ", client);
              setLiveClient(client);
            }
          })
          .catch((err) => {});
      };

      const reactToNewClient = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            console.log("reactToNewClient change: ", change);
            if (change.id === "client") {
              try {
                if (mounted) {
                  if (change.deleted) {
                    //                    return db.remove(change._id, change._rev);
                    setLiveClient(undefined);
                  } else {
                    console.log("reactToNewClient hook: ", change.doc);
                    setLiveClient(change.doc);
                  }
                }
              } catch (err) {}
            }
          });
      };

      setInitialClient().then(reactToNewClient);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db]);
  return liveClient;
};

export const useLiveUser = (db) => {
  const [liveUser, setLiveUser] = useState(undefined);

  useEffect(() => {
    let changes;
    let mounted = true;
    if (db !== undefined && db !== null) {
      const setInitialUser = () => {
        console.log("setInitialUser db: ", db);
        return db
          .get("user")
          .then((user) => {
            if (mounted) {
              console.log("setInitialUser hook: ", user);
              setLiveUser(user);
            }
          })
          .catch((err) => {});
      };

      const reactToNewUser = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (change.id === "user") {
              try {
                if (mounted) {
                  if (change.deleted) {
                    //                    return db.remove(change._id, change._rev);
                    setLiveUser(undefined);
                  } else {
                    console.log("reactToNewUser hook: ", change.doc);
                    setLiveUser(change.doc);
                  }
                }
              } catch (err) {}
            }
          });
      };

      setInitialUser().then(reactToNewUser);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db]);
  return liveUser;
};

export const useLiveParameters = (db, muid) => {
  const [liveParameters, setLiveParameters] = useState([]);

  useEffect(() => {
    let changes;
    let mounted = true;
    let list = [];
    if (db !== undefined && db !== null) {
      const setInitialParameters = () => {
        console.log("setInitialParameters: ", muid);
        return db
          .allDocs({
            include_docs: true,
            startkey: "54parameters4" + muid,
            endkey: "54parameters4" + muid + "z",
          })
          .then((allDocs) => {
            if (mounted) {
              allDocs.rows.map((row) => {
                try {
                  console.log(row.doc);
                  list = [...list, row.doc];
                } catch (err) {}
              });
              setLiveParameters(list);
            }
          })
          .catch((err) => {});
      };

      const reactToNewParameters = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (
              change.id > "54parameters4" + muid &&
              change.id < "54parameters4" + muid + "z"
            ) {
              try {
                if (mounted) {
                  let lp = list.filter((i) => {
                    return (
                      i.parameter !== change.doc.parameter &&
                      i.muid === change.doc.muid
                    );
                  });

                  console.log("liveParameters pre change filtered: ", lp);
                  if (change.deleted) {
                    setLiveParameters([...lp]);
                  } else {
                    setLiveParameters([...lp, change.doc]);
                  }
                }
              } catch (err) {}
            }
          });
      };

      setInitialParameters().then(reactToNewParameters);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db, muid]);
  return liveParameters;
};

export const useLiveDialogs = (db) => {
  const [liveDialogs, setLiveDialogs] = useState([]);

  useEffect(() => {
    let changes;
    let mounted = true;
    let list = [];
    if (db !== undefined && db !== null) {
      const setInitialDialogs = () => {
        console.log("setInitialDialogs: ");
        return db
          .allDocs({
            include_docs: true,
            startkey: "54dialog4",
            endkey: "54dialog4" + "z",
          })
          .then((allDocs) => {
            if (mounted) {
              allDocs.rows.map((row) => {
                try {
                  list = [...list, row.doc];
                } catch (err) {}
              });
              setLiveDialogs([...list]);
            }
          })
          .catch((err) => {});
      };

      const reactToNewDialogs = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (change.id > "54dialog4" && change.id < "54dialog4" + "z") {
              try {
                if (mounted) {
                  if (change.deleted) {
                    console.log("Dialog list: ", list);
                    list = list.filter(
                      (item) => !(item.mdialog === change.doc.mdialog)
                    );
                    setLiveDialogs([...list]);
                  } else if (
                    !(
                      list.map((d) => d.mdialog).indexOf(change.doc.mdialog) >=
                      0
                    )
                  ) {
                    list = [...list, change.doc];
                    console.log("Dialog list: ", list);
                    setLiveDialogs([...list]);
                  }
                }
              } catch (err) {}
            }
          });
      };

      setInitialDialogs().then(reactToNewDialogs);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db]);
  return liveDialogs;
};

export const useLivePersonas = (db) => {
  const [livePersonas, setLivePersonas] = useState([]);

  useEffect(() => {
    let changes;
    let mounted = true;
    var personaList = [];
    if (db !== undefined && db !== null) {
      const setInitialPersonas = () => {
        return db
          .get("54account_data4personas4" + "muid" + "")
          .then((personaList) => {
            if (mounted) setLivePersonas(personaList.list);
          })
          .catch((err) => {});
      };

      const reactToNewPersonas = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (change.id === "54account_data4personas4" + "muid" + "") {
              try {
                if (mounted) setLivePersonas(change.doc.list);
              } catch (err) {}
            }
          });
      };

      setInitialPersonas().then(reactToNewPersonas);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db]);
  return livePersonas;
};

export const useLiveSubscriptions = (db) => {
  const [liveSubscriptions, setLiveSubscriptions] = useState([]);

  useEffect(() => {
    let changes;
    let mounted = true;
    if (db !== undefined && db !== null) {
      const setInitialSubscriptions = () => {
        return db
          .get("54account_data4subscriptions4muid")
          .then((subDoc) => {
            console.log("Subscriptions: ", subDoc.subscriptions);
            if (mounted) setLiveSubscriptions(subDoc.subscriptions);
          })
          .catch((err) => {
            if (mounted) setLiveSubscriptions([]);
          });
      };

      const reactToNewSubscriptions = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (change.id === "54account_data4subscriptions4muid") {
              try {
                if (change.deleted) {
                  if (mounted) setLiveSubscriptions(undefined);
                } else {
                  if (mounted) setLiveSubscriptions(change.doc.subscriptions);
                }
              } catch (err) {}
            }
          });
      };

      setInitialSubscriptions().then(reactToNewSubscriptions);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db]);
  return liveSubscriptions;
};

export const useLiveSendMessages = (db) => {
  const [liveSendMessages, setLiveSendMessages] = useState([]);

  useEffect(() => {
    let mounted = true;
    let changes;
    var msgList = [];
    if (db !== undefined && db !== null) {
      const setInitialSendMessages = () => {
        msgList = [];
        return db
          .allDocs({ include_docs: true, startkey: "54send", endkey: "54sene" })
          .then((allDocs) => {
            allDocs.rows.map((row) => {
              try {
                if (true) {
                  msgList.push(row.doc);
                }
              } catch (err) {}
            });
            // sort if necessary
            if (mounted) setLiveSendMessages(msgList);
          });
      };

      const reactToNewSendMessages = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (change.id > "54send" && change.id < "54sene") {
              console.log("UPSERT SEND: ", change);
              try {
                if (change.deleted) {
                  db.get(change.id)
                    .then((d) => {
                      return db.remove(d._id, d._rev);
                    })
                    .then(function (result) {})
                    .catch(function (err) {});
                  for (let i = 0, l = msgList.length; i < l; i++) {
                    if (msgList[i]._id === change.id) {
                      msgList.splice(i, 1);
                    }
                  }
                } else {
                  let found = false;
                  for (let i = 0, l = msgList.length; i < l; ++i) {
                    // TODO: make the message match more robust in case SMID is re-used (eg for EDIT)
                    if (msgList[i].smid === change.doc.smid) {
                      found = true;
                      break;
                    }
                  }
                  found ? (found = true) : msgList.push(change.doc);
                }
                if (mounted) setLiveSendMessages([...msgList]);
              } catch (err) {}
            }
          });
      };

      setInitialSendMessages().then(reactToNewSendMessages);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db, setLiveSendMessages]);

  return liveSendMessages;
};

export const useLiveCount = (db) => {
  const [liveCount, setLiveCount] = useState({});

  useEffect(() => {
    let mounted = true;
    let changes;
    var msgCount = {};

    const sortJoin = (A, B, Delim) => {
      return A < B ? A + Delim + B : B + Delim + A;
    };

    var groupBy = (array) => {
      let t = array.reduce((r, a) => {
        // r[a.doc.mtopic] = [...(r[a.doc.mtopic] || []), a];
        if (a.doc.mtopic) {
          r[a.doc.mtopic] = (r[a.doc.mtopic] || 0) + (a.doc.read ? 0 : 1);
        }
        if (a.doc.peer && a.doc.mpersona) {
          let mdialog =
            sortJoin(a.doc.mpersona, a.doc.peer, "_") +
            (a.doc.tag ? "/" + a.doc.tag : "");
          r[mdialog] = (r[mdialog] || 0) + (a.doc.read ? 0 : 1);
        }
        return r;
      }, {});
      return t;
      // let m = Object.keys(t).reduce((r, a) => {
      //   r[a] = t[a].length;
      //   return r;
      // }, {});
      // return m;
    };

    if (db !== undefined && db !== null) {
      const setInitialCount = () => {
        return db
          .allDocs({
            include_docs: true,
            startkey: "54messages4",
            endkey: "54messages4stream",
          })
          .then((allDocs) => {
            console.log("group alldocs: ", allDocs);
            msgCount = groupBy(allDocs.rows);
            console.table(msgCount);
            if (mounted) setLiveCount(msgCount);
          });
      };

      const reactToNewCount = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (change.doc.mtopic) {
              db.allDocs({
                include_docs: true,
                startkey: "54messages4" + change.doc.mtopic,
                endkey: "54messages4" + change.doc.mtopic + "5",
              }).then((allDocs) => {
                console.log("group alldocs: ", allDocs);
                let topCount = groupBy(allDocs.rows);
                msgCount[change.doc.mtopic] = topCount[change.doc.mtopic];
                console.table(msgCount);
                if (mounted) setLiveCount({ ...msgCount });
                console.log("NOTIFY TOPIC COUNT", Date.now(), msgCount);
              });
            } else if (change.doc.peer) {
              let mdialog =
                sortJoin(change.doc.mpersona, change.doc.peer, "_") +
                (change.doc.tag ? "/" + change.doc.tag : "");
              db.allDocs({
                include_docs: true,
                startkey: "54messages4" + mdialog,
                endkey: "54messages4" + mdialog + "5",
              }).then((allDocs) => {
                console.log("group alldocs: ", allDocs);
                let topCount = groupBy(allDocs.rows);
                msgCount[mdialog] = topCount[mdialog];
                console.table(msgCount);
                if (mounted) setLiveCount({ ...msgCount });
                console.log("NOTIFY PEER COUNT", Date.now(), msgCount);
              });
            }
          });
      };

      setInitialCount().then(reactToNewCount);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db]);
  return liveCount;
};
// End liveCount

export const useLiveMessages = (db, state, topic, numMessages) => {
  const [liveMessages, setLiveMessages] = useState([]);

  useEffect(() => {
    const sortJoin = (A, B, Delim) => {
      return A < B ? A + Delim + B : B + Delim + A;
    };

    const getMdialog = (jMessage) => {
      let mdialog = undefined;
      if (jMessage.peer !== undefined) {
        mdialog =
          jMessage.visibility === "PRIVATE_MONOLOGUE"
            ? jMessage.mpersona
            : sortJoin(jMessage.mpersona, jMessage.peer, "_");
        let tag = jMessage.tag === undefined ? "" : jMessage.tag;
        mdialog = jMessage.tag === undefined ? mdialog : mdialog + "/" + tag;
      }
      return mdialog;
    };

    const timestamp = (pref1, pref2, pref3) => {
      if (pref1 && pref1 !== "") {
        return pref1;
      } else if (pref2 && pref2 !== "") {
        return pref2;
      } else if (pref3 && pref3 !== "") {
        return pref3;
      }
      return "";
    };

    let changes;
    let mounted = true;
    var msgList = [];
    let isDialog = state.dialog !== undefined;
    if (db !== undefined && db !== null) {
      const setInitialMessages = () => {
        msgList = [];
        return db
          .allDocs({
            include_docs: true,
            startkey: "54messages4" + topic,
            endkey: "54messages4" + topic + "5",
          })
          .then((allDocs) => {
            console.log("Msg_idx allDocs: ", allDocs);
            let keep = allDocs.rows
              .map((row) => row.doc.msg_idx)
              .sort()
              .slice(-400);
            let latest = keep.slice(-200);
            console.log("Msg_idx list: ", latest);
            allDocs.rows.map((row) => {
              try {
                if (latest.includes(row.doc.msg_idx)) {
                  msgList.push(row.doc);
                }
                if (!keep.includes(row.doc.msg_idx)) {
                  row.doc._deleted = true;
                  db.put(row.doc);
                }
              } catch (err) {}
            });
            // sort if necessary
            let ml = msgList
              .sort((a, b) =>
                timestamp(a.ts_server, a.ts_origin_server, a.ts_sender) >
                timestamp(b.ts_server, b.ts_origin_server, b.ts_sender)
                  ? 1
                  : -1
              )
              .slice(-numMessages);
            if (mounted) setLiveMessages([...ml]);
          });
      };

      const reactToNewMessages = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (
              change.id > "54messages4" + topic &&
              change.id < "54messages4" + topic + "5"
            ) {
              try {
                if (
                  state != undefined && isDialog
                    ? getMdialog(change.doc) === state.dialog.mdialog
                    : change.doc.mtopic === state.subscription.mtopic
                ) {
                  let found = false;
                  for (let i = 0, l = msgList.length; i < l; ++i) {
                    if (msgList[i].smid === change.doc.smid) {
                      console.log("Match: ", msgList[i]);
                      if (change.deleted) {
                        db.get(msgList[i]._id)
                          .then((d) => {
                            return db.remove(d._id, d._rev);
                          })
                          .then(function (result) {})
                          .catch(function (err) {});
                      }

                      console.log("Change: ", change.doc);
                      msgList[i] = change.doc;
                      found = true;
                      break;
                    }
                  }
                  found ? (found = true) : msgList.push(change.doc);
                  let ml = msgList
                    .sort((a, b) =>
                      timestamp(a.ts_server, a.ts_origin_server, a.ts_sender) >
                      timestamp(b.ts_server, b.ts_origin_server, b.ts_sender)
                        ? 1
                        : -1
                    )
                    .slice(-numMessages);
                  if (mounted) setLiveMessages([...ml]);
                }
              } catch (err) {}
            }
          });
      };

      setInitialMessages().then(reactToNewMessages);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db, numMessages, state, topic]);
  return liveMessages;
};

export const useLiveStreamMessages = (db, numMessages) => {
  const [liveStreamMessages, setLiveStreamMessages] = useState([]);

  useEffect(() => {
    const timestamp = (pref1, pref2, pref3) => {
      if (pref1 && pref1 !== "") {
        return pref1;
      } else if (pref2 && pref2 !== "") {
        return pref2;
      } else if (pref3 && pref3 !== "") {
        return pref3;
      }
      return "";
    };

    let changes;
    let msgList;
    let mounted = true;

    if (db !== undefined && db !== null) {
      const setInitialStreamMessages = () => {
        msgList = [];
        return db
          .allDocs({
            include_docs: true,
            startkey: "54messages4stream",
            endkey: "54messages4stream5",
          })
          .then((allDocs) => {
            let keep = allDocs.rows
              .map((row) => row.doc.msg_idx)
              .sort()
              .slice(-numMessages);
            let latest = keep.slice(-numMessages);
            allDocs.rows.map((row) => {
              try {
                // if (latest.includes(row.doc.msg_idx)) {
                //   msgList.push(row.doc);
                // }
                // if (!keep.includes(row.doc.msg_idx)) {
                row.doc._deleted = true;
                db.put(row.doc);
                // }
              } catch (err) {}
            });
            // sort if necessary
            let ml = msgList
              .sort((a, b) =>
                timestamp(a.ts_server, a.ts_origin_server, a.ts_sender) >
                timestamp(b.ts_server, b.ts_origin_server, b.ts_sender)
                  ? 1
                  : -1
              )
              .slice(-20);
            // if (mounted) setLiveStreamMessages([...ml]);
            if (mounted) setLiveStreamMessages([]);
          });
      };

      const reactToNewStreamMessages = () => {
        changes = db
          .changes({ live: true, since: "now", include_docs: true })
          .on("change", (change) => {
            if (
              change.id > "54messages4stream" &&
              change.id < "54messages4stream5"
            ) {
              try {
                let found = false;
                for (let i = 0, l = msgList.length; i < l; ++i) {
                  if (msgList[i].smid === change.doc.smid) {
                    if (change.deleted) {
                      db.get(msgList[i]._id)
                        .then((d) => {
                          return db.remove(d._id, d._rev);
                        })
                        .then((result) => {})
                        .catch((err) => {});
                    } else {
                      msgList[i] = change.doc;
                      found = true;
                    }
                    break;
                  }
                }
                found || change.deleted
                  ? (found = true)
                  : msgList.push(change.doc);
                let ml = msgList
                  .sort((a, b) =>
                    timestamp(a.ts_server, a.ts_origin_server, a.ts_sender) >
                    timestamp(b.ts_server, b.ts_origin_server, b.ts_sender)
                      ? 1
                      : -1
                  )
                  .slice(-numMessages);
                if (mounted) setLiveStreamMessages([...ml]);
              } catch (err) {}
            }
          });
      };

      setInitialStreamMessages().then(reactToNewStreamMessages);
    }
    return () => {
      changes === undefined
        ? console.log("no change to cancel")
        : changes.cancel();
      mounted = false;
    };
  }, [db, numMessages]);
  return liveStreamMessages;
};

export const useInfo = (db, dependencies) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    // eslint-disable-next-line
    const p = new Promise((resolve) => {
      db === null
        ? resolve(undefined)
        : resolve(
            db.info().then((info) => {
              setInfo(info.db_name);
              return info.db_name;
            })
          );
    }).then((r) => {
      setInfo(r);
    });
  });

  return info;
};

export const useCountDocuments = (db, dependencies) => {
  const [countDocuments, setCountDocuments] = useState(null);
  useEffect(() => {
    // eslint-disable-next-line
    const p = new Promise((resolve) => {
      db === null
        ? resolve(undefined)
        : resolve(
            db.info().then((info) => {
              setCountDocuments(info.doc_count);
              return info.doc_count;
            })
          );
    }).then((r) => {
      setCountDocuments(r);
    });
  });

  return countDocuments;
};
